"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AudienceIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.836 3.538l.001.08a3.996 3.996 0 012.099 3.521c0 .466-.08.914-.226 1.33h3.79a3.498 3.498 0 00-2.345-3.313c.47-.379.772-.963.772-1.618A2.057 2.057 0 0011.88 1.47c-1.13 0-2.045.926-2.045 2.068zm-3.672.002v.054A3.995 3.995 0 004.02 7.139c0 .467.08.916.226 1.333H.5c0-1.538.981-2.844 2.345-3.314a2.073 2.073 0 01-.771-1.618c0-1.142.915-2.068 2.045-2.068s2.045.926 2.045 2.068z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.931 7.267A2.994 2.994 0 019.665 9.72a5.058 5.058 0 013.085 4.671h-10a5.053 5.053 0 013.386-4.786 2.994 2.994 0 01-1.114-2.338c0-1.65 1.323-2.987 2.955-2.987 1.631 0 2.954 1.338 2.954 2.987z"
  })))
});
AudienceIcon.displayName = 'AudienceIcon';
var _default = exports.default = AudienceIcon;